<div class="vd-hero">
  <div class="vd-hero-logo">
    <span class="vd-hero-logo-desktop">
      <img class="vd-hero-logo-mark" src="assets/images/rosie-icon.svg" alt="" aria-hidden="true" />
      <img class="vd-hero-logo-wordmark" src="assets/images/rosie-logo-white.svg" alt="Rosie" />
    </span>
    <img class="vd-hero-logo-mobile" src="assets/images/rosie-icon-logo.svg" alt="Rosie" />
  </div>

  <div class="vd-hero-copy">
    <h1 class="vd-hero-title">Never miss a call again</h1>
    <p class="vd-hero-subtitle">Join 2000+ small businesses growing with Rosie.</p>
  </div>

  <div class="vd-hero-stats">
    <div class="vd-hero-stat" *ngFor="let stat of stats">
      <span class="vd-hero-stat-icon">
        <img [src]="stat.icon" alt="" aria-hidden="true" />
      </span>
      <span class="vd-hero-stat-text">
        <span class="vd-hero-stat-value">{{ stat.value }}</span>
        <span class="vd-hero-stat-label">{{ stat.label }}</span>
      </span>
    </div>
  </div>
</div>
